import api from './api';

class EventTypeGroupService {
  // Public endpoint - no authentication required
  async getPublicGroups() {
    try {
      const response = await api.get('/public/event-type-groups');
      return {
        success: true,
        data: response.data || response
      };
    } catch (error) {
      console.error('Error fetching public event type groups:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch event type groups'
      };
    }
  }

  // Admin endpoints - require authentication
  async getGroups(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `/admin/event-type-groups?${queryString}`
        : '/admin/event-type-groups';
      const response = await api.get(url);
      return {
        success: true,
        data: response.data || response
      };
    } catch (error) {
      console.error('Error fetching event type groups:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch event type groups'
      };
    }
  }

  async createGroup(groupData) {
    try {
      const response = await api.post('/admin/event-type-groups', groupData);
      return {
        success: true,
        data: response.data || response
      };
    } catch (error) {
      console.error('Error creating event type group:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to create event type group'
      };
    }
  }

  async updateGroup(groupId, groupData) {
    try {
      const response = await api.put(`/admin/event-type-groups/${groupId}`, groupData);
      return {
        success: true,
        data: response.data || response
      };
    } catch (error) {
      console.error('Error updating event type group:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update event type group'
      };
    }
  }

  async deleteGroup(groupId) {
    try {
      const response = await api.delete(`/admin/event-type-groups/${groupId}`);
      return {
        success: true,
        data: response.data || response
      };
    } catch (error) {
      console.error('Error deleting event type group:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to delete event type group'
      };
    }
  }
}

export default new EventTypeGroupService();
